var _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCrossGradient(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 22.4751C17.5228 22.4751 22 17.9979 22 12.4751C22 6.95225 17.5228 2.4751 12 2.4751C6.47715 2.4751 2 6.95225 2 12.4751C2 17.9979 6.47715 22.4751 12 22.4751ZM9.70711 8.76799C9.31658 8.37747 8.68342 8.37747 8.29289 8.76799C7.90237 9.15851 7.90237 9.79168 8.29289 10.1822L10.5858 12.4751L8.29289 14.768C7.90237 15.1585 7.90237 15.7917 8.29289 16.1822C8.68342 16.5727 9.31658 16.5727 9.70711 16.1822L12 13.8893L14.2929 16.1822C14.6834 16.5727 15.3166 16.5727 15.7071 16.1822C16.0976 15.7917 16.0976 15.1585 15.7071 14.768L13.4142 12.4751L15.7071 10.1822C16.0976 9.79168 16.0976 9.15851 15.7071 8.76799C15.3166 8.37747 14.6834 8.37747 14.2929 8.76799L12 11.0609L9.70711 8.76799Z"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 2,
    y1: 12.4751,
    x2: 22,
    y2: 12.4751
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6F45FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6365"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrossGradient);
export default __webpack_public_path__ + "static/media/cross-gradient.5871a18a.svg";
export { ForwardRef as ReactComponent };